<template>
    <div class="loading-logo">
        <div class="loading-logo-backgroud"></div>
        <div class="loading-logo-fill"></div>
    </div>
</template>
<script>
export default {
    name: 'loading-logo',
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.loading-logo {
    width: 60px;
    height: 36.5px;
    position: relative;
    overflow: hidden;
    .loading-logo-backgroud {
        position: absolute;
        z-index: 1;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/base/loading-logo.png');
        background-size: 100% 100%;
        background-position: 0px 0px;
        background-repeat: no-repeat;
    }
    .loading-logo-fill {
        z-index: 2;
        position: absolute;
        top: 0px;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(to left, transparent, #347fff, transparent), no-repeat;
        animation-name: mask-ani;
        animation-duration: 1s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-delay: 0s;
    }
    @keyframes mask-ani {
        0% {
            left: -100%;
        }
        100% {
            left: 100%;
        }
    }
    -webkit-mask-image: url('~@/assets/base/loading-logo.png');
    -webkit-mask-size: 100% 100%;
    -webkit-mask-position: 0px 0px;
    -webkit-mask-repeat: no-repeat;
}
</style>
